var _TitleSizesTextStyles;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ListCell from '@doordash/component-list-cell';
import { Text } from '@doordash/design-language';
export var TitleSizes = {
  Small: 'SMALL',
  Medium: 'MEDIUM',
  Large: 'LARGE'
};
export var TitleSizesTextStyles = (_TitleSizesTextStyles = {}, _defineProperty(_TitleSizesTextStyles, TitleSizes.Medium, {
  title: Text.Styles.PageTitle,
  subtext: Text.Styles.PageSubtext
}), _defineProperty(_TitleSizesTextStyles, TitleSizes.Large, {
  title: Text.Styles.MajorPageTitle,
  subtext: Text.Styles.PageSubtext
}), _TitleSizesTextStyles);
export var NavigationTypes = {
  Back: {
    icon: ListCell.IconTypes.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: ListCell.IconTypes.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: ListCell.IconTypes.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};